import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import { selectors as rootSelectors } from '../root';
import Table from './components/table/main';
import { default as createConfigForm } from './components/config-form/main';
import { default as createTransferForm } from './components/transfer-form/main';
import { default as createProtectionForm } from './components/protection-form/main';
import SelectField from '../shared/form-elements/select/field';
import Calendar from '../shared/calendar/main';

const ConfigForm = createConfigForm('configForm');
const TransferForm = createTransferForm('transferForm');
const ProtectionForm = createProtectionForm('protectionForm');

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content wm-history">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('WM actions')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="ui-control-bar">
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								{props.purses && <SelectField
									name="purse"
									placeholder="Purse"
									searchable={false}
									value={
										props.purse ?
											[{value: props.purse.pursename, label: `${props.purse.pursename} (${props.purse.amount})`}] :
											null
									}
									showLabel={false}
									options={props.purses}
									meta={{}}
									onChange={val => props.updatePurse(val[0].value)}
								/>}
							</div>
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								{
									props.purses && <Calendar
										{...props.calendar}
										onInit={props.calendarInit}
										onToggle={props.calendarToggle}
										onChange={props.calendarChange}
										onApply={() => {props.calendarApply(); props.toggleProgressBar(); props.fetchHistory();}}
										intl={props.intl}
									/>
								}
							</div>
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button
									onClick={() => props.toggleTransferForm()}
									className="ui-btn ui-btn-primary ui-btn-sign__plus"
								>
									{props.intl('Transfer money')}
								</button>
							</div>
						</div>
					</div>
					<Table {...props} />
					<div className="edit-config">
						<a href="#" onClick={(e) => {e.preventDefault(); props.toggleConfigForm();}}>
							{props.intl('Edit wm config')}
						</a>
					</div>
					<ConfigForm {...props} initialValues={{wm_config: JSON.stringify(props.config)}} />
					<TransferForm {...props} enableReinitialize={true} initialValues={props.transferFormInitialValues} />
					<ProtectionForm {...props} enableReinitialize={true} initialValues={props.protectionFormInitialValues} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		config: selectors.getConfig(state),
		table: selectors.getTable(state),
		purse: selectors.getPurse(state),
		purses: selectors.getPurses(state),
		calendar: selectors.getCalendar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		shouldShowConfigForm: selectors.getShouldShowConfigForm(state),
		shouldShowTransferForm: selectors.getShouldShowTransferForm(state),
		transferFormInitialValues: selectors.getTransferFormInitialValues(state),
		shouldShowProtectionForm: selectors.getShouldShowProtectionForm(state),
		protectionFormInitialValues: selectors.getProtectionFormInitialValues(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/wm/main.js